import styled from '@emotion/styled';

export const StartDeliveryModalStyle = styled.div`
  position: relative;
  padding: 32px 28px 20px;
  width: 468px;
  border-radius: 12px;
  background-color: var(--seed-semantic-color-paper-default);

  .close-button {
    position: absolute;
    top: 32px;
    right: 20px;
    padding: 3px;
    border: none;
    background: none;
    cursor: pointer;
    color: var(--seed-scale-color-gray-600);
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      color: var(--seed-scale-color-gray-900);
    }

    svg {
      fill: var(--seed-scale-color-gray-600);
    }
  }

  .title {
    font-size: 24px;
    font-weight: 700;
    margin-bottom: 8px;
    color: var(--seed-scale-color-gray-900);
  }

  .description {
    font-size: 14px;
    color: var(--seed-scale-color-gray-600);
    margin-bottom: 28px;
  }

  .input-label {
    font-size: 16px;
    font-weight: 500;
    color: var(--seed-scale-color-gray-900);
    margin-bottom: 16px;
  }

  .input-row {
    display: flex;
    gap: 8px;
    margin-bottom: 30px;
  }

  select {
    appearance: none;
    flex-shrink: 0;
    width: 152px;
    height: 48px;
    padding: 0 32px 0 12px;
    border: 1px solid var(--seed-scale-color-gray-400);
    border-radius: 6px;
    background-color: var(--seed-semantic-color-paper-default);
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'%3E%3Cpath d='M4 6L8 10L12 6' stroke='%23868B94' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 12px center;
    font-size: 16px;
    font-weight: 400;
    line-height: 135%;
    color: var(--seed-scale-color-gray-900);
    cursor: pointer;

    &:focus {
      outline: none;
      border-color: var(--seed-scale-color-gray-900);
    }
  }

  .input-wrapper {
    flex: 1;


    input {
      width: 100%;
      height: 48px;
      padding: 0 12px;
      border: 1px solid var(--seed-scale-color-gray-400);
      border-radius: 6px;
      font-size: 16px;
      font-weight: 400;
      line-height: 135%;
      color: var(--seed-scale-color-gray-900);

      &::placeholder {
        color: var(--seed-scale-color-gray-500);
      }

      &:focus {
        outline: none;
        border-color: var(--seed-scale-color-gray-900);
      }

      &.has-error {
        border-color: var(--seed-scale-color-red-500);

        &:focus {
          border-color: var(--seed-scale-color-red-500);
        }
      }
    }
  }

  .error-message {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 14px;
    font-weight: 400;
    line-height: 135%;
    color: var(--seed-scale-color-red-500);
    margin-top: 4px;

    svg {
      width: 16px;
      height: 16px;
      flex-shrink: 0;
    }
  }

  .button-row {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    border-top: 1px solid var(--seed-semantic-color-divider-1);
    padding-top: 24px;
  }

  .cancel-button {
    padding: 8px 16px;
    border: 1px solid var(--seed-scale-color-gray-400);
    border-radius: 6px;
    background-color: var(--seed-semantic-color-paper-default);
    font-size: 16px;
    font-weight: 700;
    line-height: 135%;
    color: var(--seed-scale-color-gray-900);
    cursor: pointer;

    &:hover {
      background-color: var(--seed-scale-color-gray-100);
    }
  }

  .submit-button {
    padding: 8px 16px;
    border: none;
    border-radius: 6px;
    background-color: var(--seed-scale-color-gray-900);
    font-size: 16px;
    font-weight: 600;
    line-height: 150%;
    color: #ffffff;
    cursor: pointer;

    &:hover:not(:disabled) {
      background-color: var(--seed-scale-color-gray-800);
    }

    &:disabled {
      background-color: var(--seed-scale-color-gray-300);
      color: var(--seed-scale-color-gray-500);
      cursor: not-allowed;
    }
  }
`;
